import { render, staticRenderFns } from "./Thanks.vue?vue&type=template&id=3fc0c8d8&scoped=true&lang=pug&"
import script from "./Thanks.vue?vue&type=script&lang=ts&"
export * from "./Thanks.vue?vue&type=script&lang=ts&"
import style0 from "./Thanks.vue?vue&type=style&index=0&id=3fc0c8d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0c8d8",
  null
  
)

export default component.exports